import * as React from "react";
import ProfileName from "../../presentations/ProfileName";

const ProfileNameContainer = () => {
  const user = {
    id: 1,
    user: {
      name: "Amit",
      firstName: "Amit",
      lastName: "Chaudhary",
      emailID: "amit@google.com",
      phoneNumber: "989797989778",
    },
    status: "ACTIVE",
    type: "limited access member",
    lastActivity: "Dec 1",
  };

  return (
    <div>
      <ProfileName data={user}></ProfileName>
    </div>
  );
};

export default ProfileNameContainer;
